export default __webpack_public_path__ + "static/school-fb2dd627f291ce22cba93a7872c36c97.gif";